import { formatPhoneNumber } from '@garner-health/components-common';

import type { Professional, ProfessionalLocation, ProviderResultItem } from '~/clients';

export function getProfessionalName({
  credentials,
  firstName,
  lastName,
}: Partial<Pick<Professional, 'credentials' | 'firstName' | 'lastName'>>): string {
  return credentials ? `${firstName} ${lastName}, ${credentials}` : `${firstName} ${lastName}`;
}

function formatProviderLocation(location: ProfessionalLocation): string[] {
  return location.lines.concat([location.city, location.state, location.zipCode].filter(Boolean).join(' '));
}

export function formatProviderInfoForClipboard(
  providers: ProviderResultItem[],
  showProviderAffiliations: boolean,
): string {
  return providers
    .map(p => {
      return [
        p.type === 'physician' ? getProfessionalName(p) : p.organizationName,
        showProviderAffiliations ? p.location.facilityName || p.location.name : undefined,
        p.phoneNumber ? formatPhoneNumber(p.phoneNumber) : p.phoneNumber,
        ...formatProviderLocation(p.location),
      ]
        .filter(Boolean)
        .join('\n');
    })
    .join('\n--------------------\n');
}
